import compact from 'lodash/compact'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'

import { selectedFoodIdState } from '../stores/atom'
import { useGetFeedingTypes, useGetFoods, useGetFoodsByRange, useGetMeals, useGetMealsByProduct } from './queries'

export const useRecentMeal = () => {
  const { data } = useGetMeals()
  const recent = data ? data[0].meal : 0
  return recent
}

export const useRecordedMeal = () => {
  const { data } = useGetMeals()

  return (data ?? []).map((el) => el.meal)
}

export const useFoods = () => {
  const { data, ...rest } = useGetFoods()
  return useMemo(
    () => ({ ...rest, data: compact((data?.pages ?? []).map((page) => page.foods).flat()) }),

    [data]
  )
}

export const useFoodsByRange = ({ startDate, endDate }: {
  startDate?: Date
  endDate?: Date
}) => {
  const { data, ...rest } = useGetFoodsByRange({ startDate, endDate })

  const foods = useMemo(
    () => compact((data?.pages ?? []).flatMap((page) => page.foods)),
    [data]
  )

  return { ...rest, data: foods }
}

export const useFindMealById = () => {
  const foodId = useRecoilValue(selectedFoodIdState)
  const { data: foods } = useFoodsByRange({
    startDate: undefined,
    endDate: undefined,
  })
  const { data: mealData, isLoading } = useGetMealsByProduct()

  const food = foods?.find((el) => el.id === foodId)
  const meals = food?.meals

  return useMemo(() => {
    return {
      date: food?.date,
      currentMeal: mealData,
      meals,
      isLoading,
    }
  }, [food, meals, mealData, isLoading])
}


export const useFindFeedingTypeById = (id: number) => {
  const { data } = useGetFeedingTypes()
  const result = data?.find((el) => el.id === id)

  return useMemo(() => ({ ...result }), [result])
}
